module.exports = __webpack_public_path__ + "img/mail3d.74321db7.png";